module.exports = __webpack_public_path__ + "img/Sardo.0f194690.jpg";